/**
 * @description 驼峰命名转换成'-'连接命名
 * @param {String} str 需要转换的字符串
 * @return {String} '-'连接形式字符串
 **/
export const camelTo_ = function(str) {
  let res = ''
  for (let i = 0; i < str.length; i++) {
    if (str[i] >= 'A' && str[i] <= 'Z') {
      if (i === 0) res += str[i].toLowerCase()
      else {
        res += '-' + str[i].toLowerCase()
      }
    } else {
      res += str[i]
    }
  }
  return res
}
export const getRandomLetter = (size = 8) => {
  let res = ''
  for (let i = 0; i < size; i++) {
    const ind = Math.floor(Math.random() * 26)
    res += String.fromCharCode(ind + 65)
  }
  return res
}
export const getUId = (letterNums = 8, numberNums = 6) => {
  const uId =
    getRandomLetter(letterNums) +
    '-' +
    Math.ceil(Math.random() * Math.pow(10, numberNums))
  return uId
}

export const addUnit = (num, unit = 'px') => {
  return num + unit
}
